module.exports = __webpack_public_path__ + "static/media/vk-logo.c2b533b5.svg";